import { render, staticRenderFns } from "./MobileBulkBanner.vue?vue&type=template&id=399f6612&scoped=true&"
import script from "./MobileBulkBanner.vue?vue&type=script&lang=js&"
export * from "./MobileBulkBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f6612",
  null
  
)

export default component.exports